<template>
  <div class="navbar">
    <nav>
      <router-link :to="{ name: 'home' }">
        <div class="logo">
          <img src="../assets/ninja.png" alt="Logo" />
          Oybek Ninja
        </div>
      </router-link>
      <div class="links">
        <div v-if="user" class="mainLinks">
          <div class="userName">
            <abbr title="Your name">Hi here, {{ user.displayName }}</abbr>
          </div>

          <div class="responsiveLinks">
            <div class="playListLinks">
              <router-link class="btn" :to="{ name: 'playlist' }">
                Create Playlist
              </router-link>
              <router-link class="btn" :to="{ name: 'UserPlaylists' }">
                My Playlists
              </router-link>
            </div>

            <div>
              <router-link :to="{ name: 'Settings' }" class="btn">
                Settings
              </router-link>
            </div>

            <button @click="handleLogOut" id="logOutBtn">Logout</button>
          </div>
        </div>
        <div v-else>
          <router-link :to="{ name: 'login' }" class="btn">Login</router-link>
          <router-link :to="{ name: 'signup' }" class="btn"
            >Sign up</router-link
          >
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { ref } from "vue";
import useLogut from "@/composable/useLogout";
import { useRouter } from "vue-router";
import getUser from "@/composable/getUser";

export default {
  setup() {
    const { error, logout, isPending } = useLogut();

    const { user } = getUser();

    const router = useRouter();

    const handleLogOut = async () => {
      await logout();
      console.log("Foydalanuvchi Log Out Bo'ldi");
      router.push("/login");
    };

    return {
      handleLogOut,
      user,
    };
  },
};
</script>

<style scoped>
.navbar {
  padding: 16px 10px;
  margin-bottom: 60px;
  background: white;
  position: fixed;
  width: 100vw;
  left: 0;
  top: 0;
  z-index: 9999999999999999999999999999999999;
}
nav {
  display: flex;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}
nav img {
  max-height: 60px;
}
nav h1 {
  margin-left: 20px;
}
nav .links {
  margin-left: auto;
  margin-right: 30px;
}
nav .links a,
button {
  margin-left: 16px;
  font-size: 14px;
}

span {
  font-size: 14px;
  display: inline-block;
  margin-left: 16px;
  padding-left: 16px;
  border-left: 1px solid #eee;
}

.logo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 26px;
}

.logo img {
  margin-right: 10px;
}

.mainLinks {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

abbr {
  cursor: pointer;
  text-decoration: none;
}

.responsiveLinks {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

@media screen and (max-width: 825px) {
  .responsiveLinks {
    display: none;
  }

  .responsiveLinks {
    display: none;
  }

  .authorLinks {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .navbar {
    display: none;
    margin: 0;
    padding: 0;
  }
}
</style>